import { useTranslation } from 'react-i18next';
import { Modal, NavMenu } from '../../components';
import './Shops.scss';
import { DisplayUtils } from '../../utils';
import { ShopsContextProvider, useShopsContext } from './contexts/ShopsContext';
import { GeolocationContextProvider } from '../../contexts/GeolocationContext';
import ShopDetail from './components/shopDetail/ShopDetail';
import MobileLayout from './layout/mobile/MobileLayout';
import DesktopLayout from './layout/desktop/DesktopLayout';
import ConvocationModal from './components/convocationModal/ConvocationModal';

const Shops = ({ fromPublic, contextProvided }) => {

  if (contextProvided) {
    return <PageContent fromPublic={fromPublic} contextProvided />;
  }

  return (
    fromPublic ? (
      <GeolocationContextProvider>
        <ShopsContextProvider fromPublic={fromPublic}>
          <PageContent fromPublic={fromPublic}/>
        </ShopsContextProvider>
      </GeolocationContextProvider>
    ) : (
      <NavMenu >
        <GeolocationContextProvider>
          <ShopsContextProvider fromPublic={fromPublic}>
            <PageContent fromPublic={fromPublic}/>
          </ShopsContextProvider>
        </GeolocationContextProvider>
      </NavMenu>
    )
  );
};

const PageContent = ({ fromPublic, contextProvided }) => {

  const { t } = useTranslation();
  const { selectedShop, types, setTypes, setSearchTerm, modalDismissed } = useShopsContext();

  return (
    <>
      <div className="Shops">
        <h1 className="sr-only">{t('Shops.pageTitle')}</h1>
        {fromPublic && !contextProvided && !modalDismissed && <ConvocationModal />}
        {DisplayUtils.isMobile() && (<MobileLayout types={types} setTypes={setTypes} setSearchTerm={setSearchTerm} fromPublic={fromPublic}/>)}
        {!DisplayUtils.isMobile() && (<DesktopLayout types={types} setTypes={setTypes} setSearchTerm={setSearchTerm} fromPublic={fromPublic}/>)}
      </div>
      <Modal
        isShowingModal={selectedShop != null}
        component={
          <ShopDetail shop={selectedShop} />
        }
      />
    </>
  );
}

export default Shops;
